import React from 'react';
import PropTypes from 'prop-types';
import { Success } from '../../../Elements';
import { Button } from 'semantic-ui-react';

const MpCopyConfirmation = ({ onClose, node, router }) =>
  <div style={{ textAlign: 'center', maxWidth: '400px', margin: '0 auto' }}>
    <Success />
    <h3 style={{ textTransform: 'capitalize' }}>
      {node.title} Copied!
    </h3>
    <p style={{ marginBottom: '2em' }}>
      The template has been copied to your account.
    </p>
    <p>
      <Button
        primary
        fluid
        content='Edit Template'
        onClick={() => router.push(`/templates/m/${node.id}/edit`)}
      />
    </p>
    <p>
      <Button
        basic
        fluid
        content='Close'
        onClick={onClose}
      />
    </p>
  </div>;

MpCopyConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
  node: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired
};

export default MpCopyConfirmation;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/CopyConfirmation.js